export default klass => {
  klass.getInstance = async () => {
    if (!klass._instance) {
      klass._instance = new klass();
      if ("tearUp" in klass._instance) {
        await klass._instance.tearUp();
      }
    }

    return klass._instance;
  };
};



// WEBPACK FOOTER //
// ./src/util/singleton.js